<template>
	<div>
		<my-navBar></my-navBar>
		<div class="content">
			<div class="width1216 screeningArea">
				<div class="line">
					<div class="title">
						选择区域：
					</div>
					<div class="valList">
						<div :class="['valItem',{'active':index==areaIndex}]" v-for="(areaItem,index) in areaList" :key='areaItem.areaName' @click='areaIndex=index'>
							{{areaItem.areaName}}
						</div>
					</div>
					<div style="clear: both;"></div>
				</div>
			</div>
			<div class="width1216">
				<div class="cineListTitle">
					<span class="block"></span>
					<span class="cineListTitleVal">影院列表</span>
				</div>
				<ul class="cineList" v-if="areaList[areaIndex]">
					<li class="cineListItem" v-for='cineItem in areaList[areaIndex].cineList' :key='cineItem.id' @click="selCine(cineItem)">
						<div class="name">{{cineItem.name}}</div>
						<div class="addr">{{cineItem.addr}}</div>
						<div class="buyTic">选座购票</div>
					</li>
				</ul>
			</div>
		</div>
		<my-footer></my-footer>
	</div>
</template>

<script>
	export default {
		name: 'cinema',
		data() {
			return {
				areaIndex: 0,
				areaList: []
			}
		},
		methods: {
			selCine: function(item) {
				this.$store.commit('updateCineInfo',{
					id: item.id,
					name: item.name,
					hall_name:'',
					addr: item.addr,
					tel: item.phone
				})
				
				setTimeout(()=>{
					this.$router.push({
						path:'/cineDetail'
					});
				},800)
			},
			axiosCineList: function() {
				var that = this;
				//影院列表
				that.axios.post('/resUrlTB/api/v2/getCityCinemas', {
						group_id: that.$store.state.group_id,
						city_name: that.$store.state.selCityInfo.region_name,
						lng: that.$store.state.lng,
						lat: that.$store.state.lat
					})
					.then(function(res) {
						if (res.data.code == 0) {
							var cinema_list = res.data.content.cinemas;
							for (var q = 0; q < cinema_list.length - 1; q++) {
								for (var r = 0; r < cinema_list.length - 1 - q; r++) {
									if (Number(cinema_list[r].distance) > Number(cinema_list[r + 1].distance)) {
										var temp = cinema_list[r];
										cinema_list[r] = cinema_list[r + 1];
										cinema_list[r + 1] = temp;
									}
								}
							}
							var newAreaList = [];
							for (var i = 0; i < cinema_list.length; i++) {
								var areaItem = {
									areaName: cinema_list[i].county,
									cineList: []
								}
								var cineItem = {
									name: cinema_list[i].cinema_name,
									addr: cinema_list[i].address,
									phone: cinema_list[i].phone,
									distance: cinema_list[i].distance,
									id: cinema_list[i].cinema_id,
									clicked: false,
									lat: cinema_list[i].latitude,
									lng: cinema_list[i].longitude
								}
								var noSameArea = true;
								for (var c = 0; c < newAreaList.length; c++) {
									if (newAreaList[c].areaName == cinema_list[i].county) {
										newAreaList[c].cineList.push(cineItem)
										noSameArea = false;
										break;
									}
								}
								if (noSameArea) {
									areaItem.cineList.push(cineItem);
									newAreaList.push(areaItem);
								}
							}
							that.areaList = newAreaList;
						}
					})
			}
		},
		created: function() {
			//请求影院列表
			this.axiosCineList();
		}
	}
</script>

<style scoped src='@/assets/css/cinema.css'>
</style>
